// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card-close[data-v-264992b9]{max-height:28px}.card-text-style[data-v-264992b9]{font-family:\"Helvetica Neue\",sans-serif;font-style:normal;font-weight:400;font-size:14px;line-height:18px;text-align:center;color:#212121}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
